import styled from 'styled-components';
import { Icon } from '../icon';

export const BreadcumbContainer = styled.nav`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    color: #78716c;
    font-family: ${(props) => props.theme.app.font};
`;

export const BreadcrumbLink = styled.button`
    color: #78716c;
    text-decoration: none;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    appearance: none;

    &:hover {
        color: #263238;
        text-decoration: underline;
    }
`;

export const BreadcrumbSeparator = styled(Icon)`
    color: #78716c;
    width: 16px;
    height: 16px;
    min-width: 16px;
`;

export const BreadcrumbCurrent = styled.span`
    color: #78716c;
    font-weight: 600;
`;
